export enum STATS_MODE {
    LESSON = 'lesson',
    PROBLEM = 'problem',
    STUDENT = 'student',
}

export enum STATS_EMPTY_STATE_MODE {
    LESSON_IN_PROGRESS = 'lesson_in_progress',
    PROBLEM_IN_PROGRESS = 'problem_in_progress',
    FINISH_FORCED = 'finish_forced',
    NOT_SOLVED = 'not_solved',
    NOT_EVALUATED = 'not_evaluated',
}

export enum STATS_THEME {
    DEFAULT = 'default',
    BLUE = 'blue',
}
